import _ from 'lodash';

import DisplayableError, { GENERIC_VALIDATION, LEVEL_ERROR, LEVEL_WARN } from './DisplayableError';

const TYPE_ERROR = 'error';

function wizardStepContainsEntity(wizardStep, entityType) {
    return wizardStep.contents
        .some(content => content.entityType === entityType);
}

function wizardStepMatchesFlowStepId(wizardStep, flowStepId) {
    if (!flowStepId) {
        return false;
    }

    if (_.isArray(wizardStep.pasFlowStepId)) {
        return _.includes(wizardStep.pasFlowStepId, flowStepId);
    }
    return wizardStep.pasFlowStepId === flowStepId;
}


function getWizardSteps({flowStepId, relatedEntity}, validationMapping) {
    return validationMapping
        .filter(wizardStep => {
            if (flowStepId) {
                return wizardStepMatchesFlowStepId(wizardStep, flowStepId);
            }
            return wizardStepContainsEntity(wizardStep, relatedEntity.type);
        })
        .map(wizardStep => wizardStep.name);
}

export default class GenericValidationIssueDE extends DisplayableError {
    constructor(validationIssue, validationMapping) {
        const {
            type,
            reason
        } = validationIssue;

        super({
            id: reason,
            title: reason,
            description: null,
            type: GENERIC_VALIDATION,
            level: type === TYPE_ERROR ? LEVEL_ERROR : LEVEL_WARN,
            wizardSteps: getWizardSteps(validationIssue, validationMapping),
            isHidden: false
        });
    }
}